import { createSelector } from 'reselect';

import type { SeoState } from './reducer';

import type { RootState } from 'typesafe-actions';

export const getSeo = (state: RootState) => state.seo;
export const getSEOData = createSelector(getSeo, (state: SeoState) => state.data);
